/**
 * @param {Object} obj
 * @param {Boolean} allowNesting
 *
 * @returns {*} Am object without undefined values
 */
var removeEmptyKeys = function removeEmptyKeys(obj, allowNesting) {
  if (allowNesting === void 0) {
    allowNesting = false;
  }

  Object.keys(obj).forEach(function (key) {
    if (obj[key] && typeof obj[key] === 'object' && allowNesting) removeEmptyKeys(obj[key]);else if (obj[key] === undefined) delete obj[key];
  });
  return obj;
};

export default removeEmptyKeys;